import type { ChatSettings } from '../types';

export const defaults: Partial<ChatSettings> = {
  phone: '',
  bubbleIcon: {
    url: 'https://static.elfsight.com/icons/app-chats-whatsapp-chat-multicolor.svg'
  },
  welcomeMessage: 'Hi there 👋 <br><br>How can I help you?',
  buttonText: 'Chat on WhatsApp',
  headerBackgroundColor: 'rgb(0, 128, 105)',
  bubbleBackgroundColor: 'rgb(37, 211, 102)',
  bubbleIconColor: 'rgb(255, 255, 255)',
  buttonBorderRadius: 24,
  chatMethod: 'startChat',
  messageBackgroundColor: 'rgb(255, 255, 255)',
  messageFieldColor: 'rgb(255, 255, 255)',
  messageButtonColor: 'rgba(37, 211, 102, 1)',
  chatWallpaperMulticolor: {
    type: 'native',
    color: 'rgb(255, 255, 255)'
  },
  align: 'right',
  buttonColor: {
    type: 'native',
    color: '#197BFF'
  }
};
